export default {
    main: {
        closeAll: 'すべてを閉じる',
        closeOther: '他を閉じる',
        myInfo: 'プロフィール',
        logOut: 'ログアウト',
        fullScreen: '全画面',
        fullScreenExit: '全画面を終了',
        lock: 'ロック',
    },
};
